import { REINSTATEMENT_CLOSURE_STATUS } from '@sparrow-card/sparrow-card-constants';

export const isClosureStatusOpen = (closureStatus?: REINSTATEMENT_CLOSURE_STATUS) =>
  closureStatus === REINSTATEMENT_CLOSURE_STATUS.Open;

export const isClosureStatusClosed = (closureStatus?: REINSTATEMENT_CLOSURE_STATUS) =>
  closureStatus === REINSTATEMENT_CLOSURE_STATUS.Closed;
